/**
 * Кассын «Урамшуулал» — худалдан авагчид юу өгсөн («Цахилгаан бараа» …).
 *
 * Кассчин шинэ нэрийг шивж зармагц сервер `lookups(PROMOTION)`-д хадгална
 * (`POST /orders` → `promotion`). Дараагийн удаа доорх чипээс сонгоно, ×
 * дарвал жагсаалтаас нууна (`DELETE /ref/promotions/:id`) — өмнөх баримт
 * нэрээ хадгална.
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, type Envelope } from '../lib/api';
import { Chip, ErrorNote, Field, Input } from './ui';

interface Promotion {
  id: string;
  labelMn: string;
}

const QUERY_KEY = ['ref-promotions'];

export function PromotionField({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  const qc = useQueryClient();
  const list = useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => api<Envelope<Promotion[]>>('/ref/lookups?category=PROMOTION&active=true'),
  });
  const hide = useMutation({
    mutationFn: (id: string) => api(`/ref/promotions/${id}`, { method: 'DELETE' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });

  const promotions = list.data?.data ?? [];
  const selected = value.trim().toLowerCase();

  return (
    <div className="flex flex-col gap-2">
      <Field label="Урамшуулал">
        <Input value={value} onChange={(e) => onChange(e.target.value)} placeholder="жишээ: Цахилгаан бараа" maxLength={150} />
      </Field>
      {promotions.length ? (
        <div className="flex flex-wrap gap-2">
          {promotions.map((p) => {
            const active = p.labelMn.toLowerCase() === selected;
            return (
              <span key={p.id} className="inline-flex items-center gap-0.5">
                <Chip active={active} onClick={() => onChange(active ? '' : p.labelMn)}>
                  {p.labelMn}
                </Chip>
                <button
                  type="button"
                  aria-label={`«${p.labelMn}» урамшууллыг жагсаалтаас хасах`}
                  title="Жагсаалтаас хасах"
                  disabled={hide.isPending}
                  onClick={() => {
                    if (!window.confirm(`«${p.labelMn}» урамшууллыг жагсаалтаас хасах уу? Өмнөх баримтад нэр нь хэвээр үлдэнэ.`)) return;
                    if (active) onChange('');
                    hide.mutate(p.id);
                  }}
                  className="grid size-11 place-items-center rounded-full text-ink-3 hover:text-alert-ink sm:size-6"
                >
                  ×
                </button>
              </span>
            );
          })}
        </div>
      ) : null}
      {hide.error ? <ErrorNote>{(hide.error as Error).message}</ErrorNote> : null}
    </div>
  );
}
